import * as React from 'react';
import Svg, { SvgProps, Path } from 'react-native-svg';

const PinIcon = (props: SvgProps) => (
  <Svg
    width={24}
    height={24}
    fill={props.fill ?? 'none'}
    {...props}
  >
    <Path
      stroke="#8AB2D9"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="m3 21 5-5m5.259 2.871c-3.744-.85-7.28-4.386-8.13-8.13-.135-.592-.202-.888-.007-1.369.194-.48.433-.63.909-.927 1.076-.672 2.242-.886 3.451-.78 1.697.151 2.546.226 2.97.005.423-.22.71-.736 1.286-1.767l.728-1.307c.48-.86.72-1.291 1.285-1.494.565-.203.905-.08 1.585.166a5.63 5.63 0 0 1 3.396 3.396c.246.68.369 1.02.166 1.585-.203.564-.633.804-1.494 1.285l-1.337.745c-1.03.574-1.544.862-1.765 1.289-.22.428-.14 1.258.02 2.918.118 1.22-.085 2.394-.766 3.484-.298.476-.447.714-.928.909-.48.194-.776.127-1.369-.008Z"
    />
  </Svg>
);
export default PinIcon;
